import axios from '@/api/axiosInstance';

export type RecordSurveyImpressionResponse = {
  surveyLastShownAt: string;
};

export default async function recordSurveyImpression(): Promise<RecordSurveyImpressionResponse> {
  const response = await axios({
    url: `${process.env.NEXT_PUBLIC_API}/teacher/surveys/impression`,
    method: 'put',
  });
  return response.data;
}
